<template>
<home-nav>
</home-nav>
<router-view></router-view>
</template>

<script>
import homeNav from "../navs/homeNav.vue";

export default {
    name: "homeLayout",
    components: {homeNav}

}
</script>

<style scoped>

</style>
